/* HUMAN-FUEL Performance Theme — Motion & Produktlogik */

(function () {
  'use strict';

  // ── Sticky Nav ────────────────────────────
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile Menu ───────────────────────────
  var burger = document.getElementById('burger');
  var navLinks = document.getElementById('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('open');
      navLinks.classList.toggle('open');
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.classList.remove('open');
        navLinks.classList.remove('open');
      });
    });
  }

  // ── Scroll Reveal ─────────────────────────
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });

    // ── Stats Counter ───────────────────────
    var animateCount = function (el) {
      var target = parseInt(el.dataset.count, 10);
      var dur = 1400;
      var start = performance.now();
      var tick = function (now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    var statsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.stat-num').forEach(animateCount);
          statsObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.stats').forEach(function (el) { statsObserver.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  // ── FAQ: nur ein Item offen ───────────────
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) faqItems.forEach(function (other) { if (other !== item) other.open = false; });
    });
  });

  // ── Hero Parallax ─────────────────────────
  var heroImg = document.querySelector('.hero-bg img');
  var heroWord = document.querySelector('.hero-big-word');
  if (heroImg && matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < window.innerHeight) {
        heroImg.style.translate = '0 ' + (y * 0.18) + 'px';
        if (heroWord) heroWord.style.translate = (y * -0.08) + 'px 0';
      }
    }, { passive: true });
  }

  // ══════════ PRODUKTSEITE ══════════
  var form = document.getElementById('ppForm');
  if (form) {
    var variantsEl = document.getElementById('ppVariants');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var select = document.getElementById('ppVariantSelect');
    var priceBox = document.getElementById('ppPrice');
    var addBtn = document.getElementById('ppAddBtn');
    var optionRows = Array.prototype.slice.call(document.querySelectorAll('.pp-option'));

    var money = function (cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    };

    var selectedValues = function () {
      return optionRows.map(function (row) {
        var active = row.querySelector('.size-pill.active');
        return active ? active.dataset.value : null;
      });
    };

    var findVariant = function (values) {
      return variants.find(function (v) {
        return values.every(function (val, i) {
          return val === null || v['option' + (i + 1)] === val;
        });
      });
    };

    var syncVariant = function () {
      var v = findVariant(selectedValues());
      if (!v) return;
      select.value = v.id;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<span class="price-old">' + money(v.compare_at_price) + '</span>';
      }
      html += '<span class="price-now">' + money(v.price) + '</span>';
      priceBox.innerHTML = html;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      var stockEl = document.getElementById('ppStock');
      if (stockEl) {
        stockEl.classList.toggle('stock-out', !v.available);
        stockEl.innerHTML = '<span class="stock-dot"></span>' + (v.available ? 'Auf Lager <span class="stock-sub">· Lieferzeit 1–3 Tage</span>' : 'Derzeit ausverkauft');
      }
    };

    optionRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var pill = e.target.closest('.size-pill');
        if (!pill) return;
        row.querySelectorAll('.size-pill').forEach(function (p) {
          p.classList.toggle('active', p === pill);
        });
        syncVariant();
      });
    });

    // Galerie-Thumbnails
    var mainImg = document.getElementById('ppMainImg');
    var thumbs = document.querySelector('.pp-thumbs');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('img[data-full]');
        if (!t) return;
        mainImg.src = t.dataset.full;
        thumbs.querySelectorAll('img').forEach(function (i) {
          i.classList.toggle('active', i === t);
        });
      });
    }

    // Mengen-Stepper
    var qtyWrap = document.getElementById('ppQty');
    var qtyInput = document.getElementById('ppQtyInput');
    if (qtyWrap && qtyInput) {
      qtyWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.qty-btn');
        if (!btn) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(99, Math.max(1, val + parseInt(btn.dataset.dir, 10)));
      });
    }
  }
})();

/* ── Widerruf-Formular-Modal ── */
(function () {
  'use strict';
  var overlay = document.getElementById('widerrufOverlay');
  if (!overlay) return;
  var open = function () { overlay.hidden = false; document.body.style.overflow = 'hidden'; };
  var close = function () { overlay.hidden = true; document.body.style.overflow = ''; };

  document.querySelectorAll('.js-widerruf').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open();
    });
  });

  var closeBtn = document.getElementById('widerrufClose');
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

  // Nach erfolgreichem Absenden (Shopify lädt die Seite neu) Modal mit Erfolg öffnen
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    open();
  }
})();
